export const GET_ALL_STAFF = 'GET_ALL_STAFF';
export const ADD_TO_STAFF = 'ADD_TO_STAFF';
export const UPDATE_STAFF = 'UPDATE_STAFF';
export const DELETE_STAFF = 'DELETE_STAFF';